import Vue from 'vue'
import axios from '@axios'

// Estado global de carga de la API: lo pinta src/components/CargaGlobal.vue (montado en App.vue).
// Cualquier llamada hecha con '@axios' cuenta automáticamente.
// Para que una llamada no muestre nada (polling, tracking...): axios.get(url, { silencioso: true })

const RETARDO_MS = 300 // no mostrar nada si responde antes (evita parpadeos)
const LENTO_MS = 10000 // a partir de aquí se avisa de que está tardando

export const carga = Vue.observable({
  pendientes: 0,
  visible: false,
  lento: false,
  errores: [], // { id, texto }
})

let timerVisible = null
let timerLento = null
let idError = 0

const actualizar = () => {
  if (carga.pendientes > 0) {
    if (!timerVisible && !carga.visible)
      timerVisible = setTimeout(() => { carga.visible = true; timerVisible = null }, RETARDO_MS)
    if (!timerLento && !carga.lento)
      timerLento = setTimeout(() => { carga.lento = true; timerLento = null }, LENTO_MS)
  } else {
    clearTimeout(timerVisible); timerVisible = null
    clearTimeout(timerLento); timerLento = null
    carga.visible = false
    carga.lento = false
  }
}

const fin = config => {
  if (config && config.__cuentaCarga) {
    config.__cuentaCarga = false
    carga.pendientes = Math.max(0, carga.pendientes - 1)
    actualizar()
  }
}

export const quitarError = id => {
  carga.errores = carga.errores.filter(e => e.id !== id)
}

const avisarError = error => {
  const { config = {}, response } = error
  if (config.silencioso || axios.isCancel(error)) return
  if (response && response.status === 401) return // ya lo gestiona jwtService (vuelve al login)
  // Solo cargas de datos: los guardados (POST/PUT...) ya los avisa cada vista
  if ((config.method || 'get').toLowerCase() !== 'get') return

  const ruta = (config.url || '').split('?')[0]
  const motivo = response ? `error ${response.status}` : 'sin conexión con el servidor'
  const texto = `No se pudieron cargar los datos (${motivo}) · ${ruta}`

  if (carga.errores.some(e => e.texto === texto)) return
  const id = ++idError
  carga.errores = [...carga.errores.slice(-2), { id, texto }]
  setTimeout(() => quitarError(id), 10000)
}

axios.interceptors.request.use(config => {
  if (!config.silencioso) {
    config.__cuentaCarga = true
    carga.pendientes += 1
    actualizar()
  }
  return config
})

axios.interceptors.response.use(
  response => { fin(response.config); return response },
  error => { fin(error.config); avisarError(error); return Promise.reject(error) },
)
